import React from 'react';
import BookLandingPage from './BookLandingPage';

const pageUrl = 'https://jerryevanoff.com/books/manufacturing-murder';
const coverImage = 'https://jerryevanoff.com/images/Evanoff_ManufacturingMurder_Ebook.jpg';

const bookSchema = {
  '@context': 'https://schema.org',
  '@type': 'Book',
  name: 'Manufacturing Murder',
  headline: 'Manufacturing Murder by Jerry Evanoff',
  author: {
    '@type': 'Person',
    name: 'Jerry Evanoff',
    url: 'https://jerryevanoff.com'
  },
  isPartOf: {
    '@type': 'BookSeries',
    name: 'Sam Norris Murder Mystery Series',
    url: 'https://jerryevanoff.com/books'
  },
  position: 1,
  bookFormat: 'https://schema.org/EBook',
  genre: [
    'Amateur Sleuth Mystery',
    'Murder Mystery',
    'Modern Whodunit',
    'Workplace Mystery',
    'Soft-Boiled Mystery'
  ],
  keywords: [
    'Manufacturing Murder',
    'Jerry Evanoff',
    'Sam Norris Murder Mystery Series',
    'amateur sleuth murder mystery',
    'modern whodunit',
    'tech-savvy sleuth',
    'workplace murder mystery',
    'programmer detective',
    'Agatha Christie-style mystery'
  ],
  description: 'Manufacturing Murder by Jerry Evanoff is a modern amateur sleuth murder mystery featuring tech-savvy programmer Sam Norris, a software installation, a factory-floor killing and an old-school whodunit puzzle.',
  image: coverImage,
  url: pageUrl,
  offers: [
    {
      '@type': 'Offer',
      name: 'Manufacturing Murder eBook',
      url: 'https://www.amazon.com/dp/B0C1W9D7CS',
      availability: 'https://schema.org/InStock',
      seller: {
        '@type': 'Organization',
        name: 'Amazon'
      }
    },
    {
      '@type': 'Offer',
      name: 'Manufacturing Murder paperback',
      url: 'https://www.amazon.com/dp/B0C1W9D7CS',
      availability: 'https://schema.org/InStock',
      seller: {
        '@type': 'Organization',
        name: 'Amazon'
      }
    },
    {
      '@type': 'Offer',
      name: 'Signed Manufacturing Murder paperback',
      url: 'https://www.etsy.com/shop/JerryEvanoffAuthor?section_id=58596111',
      availability: 'https://schema.org/InStock',
      seller: {
        '@type': 'Organization',
        name: 'Jerry Evanoff Author Etsy Shop'
      }
    }
  ]
};

const ManufacturingMurder = () => (
  <BookLandingPage
    pageUrl={pageUrl}
    pageTitle="Manufacturing Murder by Jerry Evanoff | Sam Norris Murder Mystery Book 1"
    pageDescription="Manufacturing Murder by Jerry Evanoff is a modern amateur sleuth murder mystery featuring tech-savvy programmer Sam Norris, a software installation, a factory-floor killing and an old-school whodunit puzzle."
    metaKeywords="Manufacturing Murder, Jerry Evanoff, Sam Norris Murder Mystery Series, amateur sleuth murder mystery, modern whodunit, tech-savvy sleuth, workplace murder mystery, manufacturing plant murder mystery, programmer detective, Agatha Christie-style mystery, Wyoming mystery"
    coverImage={coverImage}
    title="Manufacturing Murder"
    subtitle="Book 1 in the Sam Norris Murder Mystery Series"
    genreLine={(
      <>
        <strong>Manufacturing Murder</strong> is a modern amateur sleuth murder mystery
        featuring Sam Norris, a tech-savvy programmer whose software installation turns
        into a murder investigation.
      </>
    )}
    bodyParagraphs={[
      { text: 'Meet Sam Norris, a software developer whose latest creation promises to revolutionize manufacturing plants for a midsize company. He and his team travel to a remote city in Wyoming to implement the new system, but what they find is far from ordinary.' },
      { text: 'When the plant manager turns up dead, a whirlwind of suspects with hidden motives surfaces.', bold: true },
      { text: 'Amid the chaos, Sam crosses paths with Dani, a night-shift worker at the plant. Drawn to her, he finds himself pulled deeper into the case when she becomes the prime suspect in the eyes of the police.' },
      { text: 'But when a second body is discovered, the stakes rise again.', bold: true },
      { text: 'Can Sam solve the murders and clear Dani’s name before the killer strikes again?' }
    ]}
    perfectForText="amateur sleuth mysteries, workplace murder mysteries, modern whodunits, tech-savvy sleuths, programmer detectives and old-school puzzle plots—perfect for readers who enjoy Agatha Christie-style mysteries."
    buyLinks={{
      ebookAmazonUrl: 'https://www.amazon.com/dp/B0C1W9D7CS?maas=maas_adg_08D9EE5F6CC854C4FF53B35156191C8B_afap_abs&ref_=aa_maas&tag=maas',
      paperbackAmazonUrl: 'https://www.amazon.com/Manufacturing-Murder-Sam-Norris-Mystery/dp/B0C44FX9N4',
      paperbackBOUrl: 'https://www.barnesandnoble.com/w/manufacturing-murder-jerry-evanoff/1143430907',
      etsySignedPaperbackUrl: 'https://www.etsy.com/shop/JerryEvanoffAuthor?section_id=58596111'
    }}
    readingOrder={[
      { title: 'Manufacturing Murder', subtitle: 'Book 1', current: true },
      { title: 'The Library (Novella)', subtitle: 'Book 1.5' },
      { title: 'Inheriting Murder', subtitle: 'Book 2' },
      { title: 'Networking Murder', subtitle: 'Book 3' }
    ]}
    schema={bookSchema}
  />
);

export default ManufacturingMurder;
